import styled from "styled-components";

import { TAB_BAR } from "../../constants/tabBar";
import { fontSizes } from "../../shared/styles/typography";

export const Body = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 40px;
`;

export const SuggestionCard = styled.article`
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border, #e8eaf0);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

export const SuggestionTitle = styled.h2`
  margin: 0;
  font-size: ${fontSizes.base}px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-title, #1e293b);
`;

export const SuggestionDesc = styled.p`
  margin: 0;
  font-size: ${fontSizes.base}px;
  line-height: 1.5;
  color: var(--color-text-secondary, #64748b);
  white-space: pre-wrap;
`;

export const Meta = styled.span`
  font-size: ${fontSizes.sm}px;
  color: var(--color-text-tertiary, #6e6a7c);
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 20px;
  color: #6e6a7c;

  svg {
    margin-bottom: 16px;
    opacity: 0.5;
  }

  h2 {
    font-size: ${fontSizes.xl}px;
    font-weight: var(--font-weight-semibold);
    color: var(--color-text-title, #1e293b);
    margin: 0 0 8px;
  }

  p {
    margin: 0 0 16px;
    font-size: ${fontSizes.sm}px;
    line-height: 1.5;
  }

  button {
    border: none;
    border-radius: 12px;
    background: ${TAB_BAR.primary};
    color: #fff;
    font-size: ${fontSizes.base}px;
    font-weight: var(--font-weight-semibold);
    padding: 12px 20px;
    cursor: pointer;
  }
`;
